module.exports = __webpack_public_path__ + "static/media/harbour.2e500a66.jpg";